import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';

import rootReducer from './modules/root';
import summaryReducer from './modules/summary';
import adminsReducer from './modules/admins';
import showcaseReducer from './modules/showcase';
import statisticsReducer from './modules/statistics/general';
import statisticsInvalidReducer from './modules/statistics/invalid';
import conversionsReducer from './modules/statistics/conversions';
import unacceptableConversionsReducer from './modules/statistics/unacceptable-conversions';
import unacceptableConversionsStatReducer from './modules/statistics/unacceptable-conversions-stat';
import campaignDomainsReducer from './modules/campaign-domains';
import programsListReducer from './modules/programs/list';
import programsAdditionalListReducer from './modules/programs/additional-list';
import programsEditorReducer from './modules/programs/editor';
import programsInfoReducer from './modules/programs/info';
import programsCategoryListReducer from './modules/programs/category/list';
import programsCategoryEditorReducer from './modules/programs/category/editor';
import threadsListReducer from './modules/threads/list';
import threadsItemReducer from './modules/threads/item';
import affiliatesListReducer from './modules/affiliates/list';
import affiliateEditReducer from './modules/affiliates/edit';
import topOffersListReducer from './modules/top-offers';
import topAffiliatesListReducer from './modules/top-affiliates';
import topCountriesListReducer from './modules/top-countries';
import newsListReducer from './modules/news/list';
import newsEditReducer from './modules/news/edit';
import discountsListReducer from './modules/discounts/list';
import discountsEditReducer from './modules/discounts/edit';
import offerLangRulesListReducer from './modules/offer-location-rules/lang-rules/list';
import offerLangRulesEditReducer from './modules/offer-location-rules/lang-rules/edit';
import offerGeoRulesListReducer from './modules/offer-location-rules/geo-rules/list';
import offerGeoRulesEditReducer from './modules/offer-location-rules/geo-rules/edit';
import payoutSystemsReducer from './modules/payout-systems';
import payoutsListReducer from './modules/payouts/list';
import payoutRequestsListReducer from './modules/payout-requests/list-request';
import payoutRequestsPayoutMatrixReducer from './modules/payout-requests/payout-matrix';
import payoutRequestRegisterReducer from './modules/payout-requests/list-register';
import payoutRequestTrafficScaling from './modules/payout-requests/list-traffic-scaling';
import payoutRequestStatReducer from './modules/payout-requests/list-stat';
import riskPayoutsReducer from './modules/payout-requests/risk-payouts';
import payoutRequestHistoryReducer from './modules/payout-requests/request-history';
import landingSnippetsReducer from './modules/landing-snippets';
import affiliatesActivityReducer from './modules/affiliates-activity';
import managersAffiliatesActivityReducer from './modules/managers-affiliates-activity';
import registrationAnalyticsReducer from './modules/registration-analytics';
import marketingFunnelReducer from './modules/marketing-funnel/main';
import marketingFunnelRegistrationActivityReducer from './modules/marketing-funnel/registration-activity';
import marketingFunnelActivityReducer from './modules/marketing-funnel/activity';
import marketingFunnelAffiliateStatReducer from './modules/marketing-funnel/affiliate-stat';
import productCapsReducer from './modules/product-cap';
import prioritiesReducer from './modules/priorities';
import weeklyReportReducer from './modules/weekly-report';
import quidsReportReducer from './modules/quids-report';
import dailyApprovesListReducer from './modules/daily-approves-list';
import affiliateProfileReducer from './modules/affiliates/profile';
import promoCodesReducer from './modules/promo-codes';
import manualMailingsListReducer from './modules/mailings-new/manual-mailings/list';
import manualMailingsEditorReducer from './modules/mailings-new/manual-mailings/editor';
import triggeredMailingsListReducer from './modules/mailings-new/triggered-mailings/list';
import triggeredMailingsEditorReducer from './modules/mailings-new/triggered-mailings/editor';
import mailingsImageListReducer from './modules/mailings-new/image/list';
import mailingsImageEditorReducer from './modules/mailings-new/image/editor';
import adminProfileReducer from './modules/admins/profile';
import definedReferersReducer from './modules/defined-referers';
import externalThreadsListReducer from './modules/external-threads/list';
import externalThreadsItemReducer from './modules/external-threads/item';
import campaignsListReducer from './modules/campaigns';
import pollsListReducer from './modules/polls';
import wmReducer from './modules/wm';
import advRequestsReducer from './modules/advertisers-requests/list';
import affiliatesRedeemReducer from './modules/affiliates-redeem';
import affiliateManagersProductivityReducer from './modules/affiliate-managers-productivity';
import trafficAccountingReducer from './modules/traffic-accounting';
import alertsAnalyticsReducer from './modules/alerts-analytics';
import conversionsApproveReducer from './modules/conversions-approve';
import conversionsApproveRequestsReducer from './modules/conversions-approve-requests';
import conversionsGarantApproveRequestsReducer from './modules/conversions-garant-approve-requests';
import guarantApproveRequestListsReducer from './modules/guarant-approve-register/list';
import guarantApproveRequestEditorReducer from './modules/guarant-approve-register/editor';

import limitedGarantsReducer from './modules/limited-garants/list';
import limitedGarantsEditorReducer from './modules/limited-garants/editor';

import limitedGarantsAnalisysReducer from './modules/limited-garants-analysis/list';

import garantForecastReducer from './modules/garant-forecast';
import finReportsReducer from './modules/fin-reports';
import landingReportsReducer from './modules/landing-reports';
import affiliateReportsReducer from './modules/affiliate-reports';
import promoReportsReducer from './modules/promo-reports';
import payoutLogTransfersReducer from './modules/payout-log/transfers';
import payoutLogPaymentsReducer from './modules/payout-log/payments';
import chainListReducer from './modules/chaining/list';
import chainEditorReducer from './modules/chaining/editor';
import applicantListReducer from './modules/applicants/list';
import applicantEditReducer from './modules/applicants/editor';
import applicantProfileReducer from './modules/applicants/profile';
import goodsListReducer from './modules/goods/list';
import GoodsEditReducer from './modules/goods/editor';
import goodCategoryListReducer from './modules/goods/category/list';
import goodCategoryEditorReducer from './modules/goods/category/editor';
import missionsListReducer from './modules/missions/list';
import missionsEditorReducer from './modules/missions/editor';
import achievementsListReducer from './modules/missions/achievement/list';
import achievementsEditorReducer from './modules/missions/achievement/editor';
import bmAccountsCategoryEditorReducer from './modules/bm-accounts/category/editor';
import bmAccountsCategoryListReducer from './modules/bm-accounts/category/list';
import bmAccountsEditorReducer from './modules/bm-accounts/editor';
import bmAccountsListReducer from './modules/bm-accounts/list';
import exchangeRatesReducer from './modules/exchange-rates';
import marketingReportsReducer from './modules/marketing-reports/';
import ranksPointsReportReducer from './modules/ranks-points-report';
import contestReducer from './modules/contests';

import cplRulesReducer from './modules/cpl-rules';
import approveRejectPayoutsReducer from './modules/approve-reject';
import campaignPayoutReducer from './modules/campaigns/payout-editor';
import geoPayoutRatesReducer from './modules/geo-payout-rates';

import postbackLog from './modules/postback-log';

import bannersPublicationListReducer from './modules/banners/publication/list';
import bannersPublicationEditorReducer from './modules/banners/publication/editor';
import bannersContentListReducer from './modules/banners/content/list';
import bannersContentEditorReducer from './modules/banners/content/editor';
import bannersImageListReducer from './modules/banners/image/list';
import bannersImageEditorReducer from './modules/banners/image/editor';
import popupsPopupListReducer from './modules/popups/popup/list';
import popupsPopupEditorReducer from './modules/popups/popup/editor';
import popupsImageListReducer from './modules/popups/image/list';
import popupsImageEditorReducer from './modules/popups/image/editor';

import blogArticleListReducer from './modules/blog/article/list';
import blogArticleEditorReducer from './modules/blog/article/editor';
import blogArticleImageListReducer from './modules/blog/article-image/list';
import blogArticleImageEditorReducer from './modules/blog/article-image/editor';
import blogArticleTagListReducer from './modules/blog/article-tag/list';
import blogArticleTagEditorReducer from './modules/blog/article-tag/editor';
import blogArticleCommentListReducer from './modules/blog/article-comment/list';
import blogArticleCommentEditorReducer from './modules/blog/article-comment/editor';

import { errorReducer } from './modules/shared/http';

export default combineReducers({
	routing: routerReducer,
	form: formReducer,
	root: rootReducer,
	summary: summaryReducer,
	admins: adminsReducer,
	showcase: showcaseReducer,
	exchangeRates: exchangeRatesReducer,
	statistics: statisticsReducer,
	invalid: statisticsInvalidReducer,
	conversions: conversionsReducer,
	unacceptableConversions: unacceptableConversionsReducer,
	unacceptableConversionsStat: unacceptableConversionsStatReducer,
	campaignDomains: campaignDomainsReducer,
	programsList: programsListReducer,
	programsAdditionalList: programsAdditionalListReducer,
	programsEditor: programsEditorReducer,
	programsInfo: programsInfoReducer,
	programsCategoryList: programsCategoryListReducer,
	programsCategoryEditor: programsCategoryEditorReducer,
	threadsList: threadsListReducer,
	topOffersList: topOffersListReducer,
	topAffiliatesList: topAffiliatesListReducer,
	topCountriesList: topCountriesListReducer,
	threadsItem: threadsItemReducer,
	extThreadsList: externalThreadsListReducer,
	extThreadsItem: externalThreadsItemReducer,
	affiliatesList: affiliatesListReducer,
	affiliateEdit: affiliateEditReducer,
	newsList: newsListReducer,
	newsEdit: newsEditReducer,
	contests: contestReducer,
	discountsList: discountsListReducer,
	discountsEdit: discountsEditReducer,
	offerLangRulesList: offerLangRulesListReducer,
	offerLangRulesEdit: offerLangRulesEditReducer,
	offerGeoRulesList: offerGeoRulesListReducer,
	offerGeoRulesEdit: offerGeoRulesEditReducer,
	payoutSystems: payoutSystemsReducer,
	payoutsList: payoutsListReducer,
	payoutRequests: payoutRequestsListReducer,
	payoutRequestHistory: payoutRequestHistoryReducer,
	payoutRequestRegister: payoutRequestRegisterReducer,
	payoutRequestTrafficScaling: payoutRequestTrafficScaling,
	payoutRequestStat: payoutRequestStatReducer,
	riskPayouts: riskPayoutsReducer,
	payoutRequestsPayoutMatrix: payoutRequestsPayoutMatrixReducer,
	landingSnippets: landingSnippetsReducer,
	affiliatesActivity: affiliatesActivityReducer,
	managersAffiliatesActivity: managersAffiliatesActivityReducer,
	registrationAnalytics: registrationAnalyticsReducer,
	marketingFunnel: marketingFunnelReducer,
	marketingFunnelRegistrationActivity: marketingFunnelRegistrationActivityReducer,
	marketingFunnelAffiliateStat: marketingFunnelAffiliateStatReducer,
	marketingFunnelActivity: marketingFunnelActivityReducer,
	productCaps: productCapsReducer,
	priorities: prioritiesReducer,
	weeklyReport: weeklyReportReducer,
	quidsReport: quidsReportReducer,
	dailyApprovesList: dailyApprovesListReducer,
	affiliateProfile: affiliateProfileReducer,
	promoCodes: promoCodesReducer,
	manualMailingsList: manualMailingsListReducer,
	manualMailingsEditor: manualMailingsEditorReducer,
	triggeredMailingsList: triggeredMailingsListReducer,
	triggeredMailingsEditor: triggeredMailingsEditorReducer,
	mailingsImageList: mailingsImageListReducer,
	mailingsImageEditor: mailingsImageEditorReducer,
	adminProfile: adminProfileReducer,
	approveRejectPayouts: approveRejectPayoutsReducer,
	campaignPayout: campaignPayoutReducer,
	geoPayoutRates: geoPayoutRatesReducer,
	definedReferers: definedReferersReducer,
	campaignsList: campaignsListReducer,
	pollsList: pollsListReducer,
	postbackLog: postbackLog,
	wm: wmReducer,
	advRequestsList: advRequestsReducer,
	affiliatesRedeem: affiliatesRedeemReducer,
	affiliateManagersProductivity: affiliateManagersProductivityReducer,
	trafficAccounting: trafficAccountingReducer,
	alertsAnalytics: alertsAnalyticsReducer,
	conversionsApprove: conversionsApproveReducer,
	conversionsApproveRequests: conversionsApproveRequestsReducer,
	conversionsGarantApproveRequests: conversionsGarantApproveRequestsReducer,
	guarantApproveRequestsList: guarantApproveRequestListsReducer,
	guarantApproveRequestEditor: guarantApproveRequestEditorReducer,
	limitedGarants: limitedGarantsReducer,
	limitedGarantsEditor: limitedGarantsEditorReducer,
	limitedGarantsAnalisys: limitedGarantsAnalisysReducer,
	garantForecast: garantForecastReducer,
	finReports: finReportsReducer,
	landingReports: landingReportsReducer,
	affiliateReports: affiliateReportsReducer,
	promoReports: promoReportsReducer,
	payoutLogTransfers: payoutLogTransfersReducer,
	payoutLogPayments: payoutLogPaymentsReducer,
	chainList: chainListReducer,
	chainEdit: chainEditorReducer,
	applicantsList: applicantListReducer,
	applicantEditor: applicantEditReducer,
	applicantProfile: applicantProfileReducer,
	goodsList: goodsListReducer,
	goodsEditor: GoodsEditReducer,
	goodCategoryList: goodCategoryListReducer,
	goodCategoryEditor: goodCategoryEditorReducer,
	missionsList: missionsListReducer,
	missionsEditor: missionsEditorReducer,
	achievementsList: achievementsListReducer,
	achievementsEditor: achievementsEditorReducer,
	apiErrors: errorReducer,
	marketingReports: marketingReportsReducer,
	bmAccountsCategoryEditor: bmAccountsCategoryEditorReducer,
	bmAccountsCategoryList: bmAccountsCategoryListReducer,
	bmAccountsEditor: bmAccountsEditorReducer,
	bmAccountsList: bmAccountsListReducer,

	bannersPublicationList: bannersPublicationListReducer,
	bannersPublicationEditor: bannersPublicationEditorReducer,
	bannersContentList: bannersContentListReducer,
	bannersContentEditor: bannersContentEditorReducer,
	bannersImageList: bannersImageListReducer,
	bannersImageEditor: bannersImageEditorReducer,

	blogArticleList: blogArticleListReducer,
	blogArticleEditor: blogArticleEditorReducer,
	blogArticleImageList: blogArticleImageListReducer,
	blogArticleImageEditor: blogArticleImageEditorReducer,
	blogArticleTagList: blogArticleTagListReducer,
	blogArticleTagEditor: blogArticleTagEditorReducer,
	blogArticleCommentList: blogArticleCommentListReducer,
	blogArticleCommentEditor: blogArticleCommentEditorReducer,

	cplRules: cplRulesReducer,
	...((process.env.CPA_ENV === 'rocket') && {
		ranksPointsReport: ranksPointsReportReducer,
		popupsPopupList: popupsPopupListReducer,
		popupsPopupEditor: popupsPopupEditorReducer,
		popupsImageList: popupsImageListReducer,
		popupsImageEditor: popupsImageEditorReducer
	})
});



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/reducer.js